"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityOperations = void 0;
class SecurityOperations {
    constructor(users, groups) {
        this.users = users;
        this.groups = groups;
    }
}
exports.SecurityOperations = SecurityOperations;
